<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <l-data-table
      :headers="header"
      title-text="计费结果列表"
      search-text="请输入车牌号"
      :get-data-func="getResultList"></l-data-table>
    </v-card>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../ladmin/utils/time'
export default {
  components: {LDataTable},
  data () {
    return {
      header: [
        {text: '车辆号牌', value: 'plateNum', align: 'left'},
        {text: '用户ID', value: 'userId', align: 'left'},
        {text: '用户组ID', value: 'usrgrpId', align: 'left', sortable: false},
        {text: '规则类型', value: 'chargingType', align: 'left', sortable: false, f: (v) => (v === 'simple') ? '简单型计费规则' : '周期型计费规则'},
        {text: '执行结果', value: 'result', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: false, f: (v) => time.stringify(new Date(v))}
      ]
    }
  },
  methods: {
    async getResultList ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('charging/getCalculateResultList', {pagination, sortStack, filterItems, search: {key: 'plateNum', value: search}})
      return {items, amount}
    }
  }
}
</script>
